// Lightweight structured logger for the agent AI reply assistant.
// Disabled by default in production; toggle via `enableDebug()` or by setting
// `window.__AI_ASSIST_DEBUG = true` from the browser console. Mirrors the
// translation feature logger so debugging is consistent across AI extensions.
const SCOPE = 'ai_assist';
const SAFE_KEYS = new Set([
  'event',
  'conversationId',
  'requestId',
  'status',
  'count',
  'durationMs',
  'autoReplyOn',
]);

const isEnabled = () => {
  if (typeof window === 'undefined') return false;
  if (window.__AI_ASSIST_DEBUG === true) return true;
  const flag = window.localStorage?.getItem('ai_assist_debug');
  return flag === '1' || flag === 'true';
};

// Never log raw draft text (it contains customer content); unknown string
// fields are reduced to their length only.
const stripSensitive = payload => {
  if (!payload || typeof payload !== 'object') return payload;
  const cleaned = {};
  Object.keys(payload).forEach(key => {
    if (SAFE_KEYS.has(key)) {
      cleaned[key] = payload[key];
    } else if (typeof payload[key] === 'string') {
      cleaned[key] = `len:${payload[key].length}`;
    } else {
      cleaned[key] = payload[key];
    }
  });
  return cleaned;
};

export const logger = {
  enableDebug() {
    if (typeof window !== 'undefined') {
      window.__AI_ASSIST_DEBUG = true;
      window.localStorage?.setItem('ai_assist_debug', '1');
    }
  },
  disableDebug() {
    if (typeof window !== 'undefined') {
      window.__AI_ASSIST_DEBUG = false;
      window.localStorage?.removeItem('ai_assist_debug');
    }
  },
  isEnabled,
  info(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.log(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  warn(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.warn(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  error(event, payload = {}) {
    // eslint-disable-next-line no-console
    console.error(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
};

export default logger;
